import School from 'actions/school';

export default School.createReducer();
